import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function AboutPreview() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-sand py-24 lg:py-32">
      <span aria-hidden="true" className="pointer-events-none absolute right-6 top-14 select-none font-serif text-7xl text-atlantic/[0.06] sm:text-8xl lg:right-16">10</span>
      <Reveal className="mx-auto max-w-4xl px-5 text-center lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-ocean">About the Institute</p>
        <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-atlantic sm:text-4xl lg:text-[2.75rem]">
          Why Atlantic Bridge Exists
        </h2>
        <p className="mx-auto mt-8 max-w-3xl text-base leading-relaxed text-slate-600 sm:text-lg">
          For generations, Africa–Caribbean relations have often been framed through symbolism, heritage and ceremonial
          diplomacy. Those connections matter, but they are insufficient on their own. Atlantic Bridge exists to
          document what is happening, expose what is missing and create an informed public record of what deeper
          cooperation could achieve.
        </p>
        <a
          data-testid="about-institute-button"
          href="#founder"
          className="group mt-10 inline-flex items-center gap-2 border border-atlantic px-7 py-3.5 text-sm font-semibold tracking-wide text-atlantic transition-colors hover:bg-atlantic hover:text-white"
        >
          About the Institute
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </Reveal>
    </section>
  );
}
